import { render, staticRenderFns } from "./CurrentRentalInformation.vue?vue&type=template&id=68aad48e&"
import script from "./CurrentRentalInformation.vue?vue&type=script&lang=js&"
export * from "./CurrentRentalInformation.vue?vue&type=script&lang=js&"
import style0 from "./CurrentRentalInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BRow} from 'bootstrap-vue'
    installComponents(component, {BRow})
    

export default component.exports